// extracted by mini-css-extract-plugin
export default {"drone":"styles_drone__tofSU","status":"styles_status__79AUb"};